import React from 'react';

import { CmsCtaType } from '../../cms/types';
import { Button } from '../../../design-system';
import { ColorButton } from '../../common/components/Custom';

type Props = {
  id: string;
  text: string;
  type: CmsCtaType;
  color?: string;
  fontColor?: string;
  onClick?: () => void;
};

export const BannerCta = ({ id, text, type, color, fontColor, onClick }: Props) =>
  type === 'black button' ? (
    <Button id={id} onClick={onClick} aria-label={text}>
      {text}
    </Button>
  ) : type === 'white button' ? (
    <Button id={id} preset="primaryLight" onClick={onClick} aria-label={text}>
      {text}
    </Button>
  ) : type === 'ghost button' && text !== '' ? (
    <Button id={id} preset="subtle" onClick={onClick} aria-label={text}>
      {text}
    </Button>
  ) : type === 'color button' ? (
    <ColorButton id={id} cmsColor={color} fontColor={fontColor} onClick={onClick} aria-label={text}>
      {text}
    </ColorButton>
  ) : null;
